"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildExampleContext = void 0;
const lodash_1 = require("lodash");
function buildExampleContext(flow) {
    const buildField = (fields) => fields.reduce((obj, field) => {
        if (field.example) {
            // @ts-ignore
            obj[field.id] = (0, lodash_1.cloneDeep)(field.example);
        }
        else {
            // @ts-ignore
            obj[field.id] = (0, lodash_1.cloneDeep)(field.default);
        }
        return obj;
    }, {});
    const buildState = () => {
        if (flow.stateSchema) {
            return buildField(flow.stateSchema);
        }
        return {};
    };
    const buildParams = () => {
        if (flow.params) {
            return buildField(flow.params);
        }
        return {};
    };
    const context = { params: buildParams(), state: buildState() };
    return context;
}
exports.buildExampleContext = buildExampleContext;
//# sourceMappingURL=exampleContext.js.map